module.exports = __webpack_public_path__ + "static/media/img.898297b2.jpg";